import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { AnnouncementStyle } from 'api/announcements/models/AnnouncementStyle';
import { useAnnouncements } from './AnnouncementsProvider';
import { pickMostSevereColor } from './announcementStyleColors';
import styles from './AnnouncementsReopenButton.module.scss';

const TOOLTIP_ID = 'announcements-reopen-tip';

const AnnouncementsReopenButton: React.FC = () => {
    const { t } = useTranslation();
    const { active, dismissedActiveCount, restoreAll } = useAnnouncements();

    if (dismissedActiveCount === 0) {
        return <></>;
    }

    const colors = pickMostSevereColor(active.map(a => ({ style: a.style as AnnouncementStyle, textColor: a.textColor, backgroundColor: a.backgroundColor })));

    return (
        <>
            <button
                type="button"
                className={styles.button}
                onClick={restoreAll}
                data-tip={t('announcements.reopen') as string}
                data-for={TOOLTIP_ID}
                aria-label={t('announcements.reopen') as string}
                style={{ color: colors.accentColor }}
            >
                <FiAlertTriangle />
            </button>
            <ReactTooltip id={TOOLTIP_ID} place="top" effect="solid" />
        </>
    );
};

export default AnnouncementsReopenButton;
